"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var PersonReference = require('../core/person-reference');

var errorValidator = require('../../helper/flexible-questionnaire/fq-helper');

var FlexibleQuestionnaire = /*#__PURE__*/function () {
  function FlexibleQuestionnaire(opt) {
    _classCallCheck(this, FlexibleQuestionnaire);

    this._id = null;
    this.responses = null;
    this.templateId = null;
    this.createdBy = null;
    this.createdDate = null;
    this.lastModifiedBy = null;
    this.lastModifiedDate = null;

    if (opt) {
      this.fillBaseObject(opt);
    }
  }

  _createClass(FlexibleQuestionnaire, [{
    key: "fillBaseObject",
    value: function fillBaseObject(opt) {
      this._id = new ObjectId(opt._id);
      this.responses = opt.responses;
      this.templateId = opt.templateId;
      this.createdBy = new PersonReference(opt.createdBy);
      this.createdDate = opt.createdDate ? new Date(opt.createdDate) : null;
      this.lastModifiedBy = new PersonReference(opt.lastModifiedBy);
      this.lastModifiedDate = opt.lastModifiedDate ? new Date(opt.lastModifiedDate) : null;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "isValid",
    value: function isValid(questions, answers) {
      return errorValidator.isFormValid(questions, answers);
    }
  }]);

  return FlexibleQuestionnaire;
}();

module.exports = FlexibleQuestionnaire;